<template lang="html">
	<div class="container-fluid p-5">
		<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header">
						<h6>
							<button class="back-btn" type="button" @click="back()">
								<i class="fas fa-arrow-left"></i>
							</button>
							 Edit Bank Info
						</h6>
					</div>
					<div class="card-body">
						<form @submit.prevent="onSubmit">
							<div v-if="message" class="alert alert-danger">{{ message }}</div>
							<div class="form-group row">
								   <div class="col-md-6">
									   <label for="bankSelect" class="col-form-label">Payment Method <span class="text-danger">*</span></label>
									   <select v-model="bankRequest.payment_method_id" @blur="validationRule()" class="form-control" id="bankSelect">
										   <option value="">Select Payment Method</option>
										   <option v-for="bank in paymentMethod" :key="bank.id" :value="bank.id">{{ bank.name }}</option>
									   </select>
									   <small class="text-danger">{{validationData.bank}}</small>
								   </div>
									<div class="col-md-6">
										<label for="inputName" class="col-form-label">Name <span class="text-danger">*</span></label>
										<input type="text" v-model="bankRequest.name" @blur="validationRule()" class="form-control" id="inputName">
										<small class="text-danger">{{validationData.name}}</small>
									</div>
							</div>
							<div class="form-group row">
								   <div class="col-md-6">
									   <label for="inputAccountNumber" class="col-form-label">Account Number <span class="text-danger">*</span></label>
									   <input type="text" v-model="bankRequest.account_number" @blur="validationRule()" class="form-control" id="inputAccountNumber">
									   <small class="text-danger">{{validationData.account_number}}</small>
								   </div>
								   <div class="col-md-6 pt-4">
									   <div class="form-check" style="margin-top: 20px;">
										   <input class="form-check-input" type="checkbox" id="activeCheckbox" v-model="bankRequest.active">
										   <label class="form-check-label" for="activeCheckbox">
											   Active
										   </label>
									   </div>
								   </div>
								</div>

							<button type="submit" class="btn btn-primary float-save">Submit</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="js">
	import {
		mapState,
		mapActions
	} from 'vuex'
	import env from '../../enviorments'
	import Loading from 'vue-loading-overlay'
	import 'vue-loading-overlay/dist/vue-loading.css';
	export default {
		name: 'bankEdit',
		metaInfo: {
            title: "Bank Info Edit",
            titleTemplate: "%s ← BXB",
        },
		components: {
			Loading
		},
		data() {
			return {
				env,
				isLoading: false,
				fullPage: true,
				paymentMethod: [],
				message: "",
				filter: {
					page: "",
                    orderBy: "",
                    sortKey: "",
				},
				bankRequest: {
					name: "",
					account_number: "",
					payment_method_id: "",
					active: false
				},
				validationData: {
					name: "",
					account_number: "",
					payment_method_id: ""
				}
			}
		},
		watch: {
			async $route(to, from) {
			},
		},
		computed: {},
		methods: {
			...mapActions({
				bankUpdateAction: 'bankUpdateAction',
				bankDetailAction: 'bankDetailAction',
				paymentMethodAction: 'paymentMethodAction',
			}),
			async getPaymentMethod(){
				await this.paymentMethodAction().then(res => {
					this.paymentMethod = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			async getFields(){
				let option = {
					type: "update",
					id: this.bankRequest.id
				}
				await this.bankDetailAction({
					...option
				}).then(res => {
					this.bankRequest.name = res.data.name
					this.bankRequest.account_number = res.data.account_number
					this.bankRequest.payment_method_id = res.data.payment_method_id
					this.bankRequest.active = res.data.is_active === true || res.data.is_active === 1 ? true : false
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			async onSubmit() {
				this.isLoading = true
				let validation = this.validationRule()
				if (validation == true) {
					this.isLoading = false
					return
				}
		
				const formData = new FormData();
				formData.append('id', this.bankRequest.id);
				formData.append('name', this.bankRequest.name);
				formData.append('account_number', this.bankRequest.account_number);
				formData.append('payment_method_id', this.bankRequest.payment_method_id);
				formData.append('is_active', this.bankRequest.active ? 1 : 0);

				await this.bankUpdateAction(
					formData
				).then(res => {
					if(res.success === true) {
						this.back()
					} else {
						this.message = res.message
					}
					this.isLoading = false;
				}).catch(err => this.isLoading = true)
			},
			back() {
				this.$router.replace({ 
					path: 'bank-list', 
					query: { 
						page: this.filter.page, 
						orderBy: this.filter.orderBy, 
						sortKey: this.filter.sortKey, 
					} 
				}).catch(()=>{})
			},
			validationRule() {
				let isValidation = []
				if (this.bankRequest.payment_method_id == "") {
					this.validationData.payment_method_id = "The payment method field is required."
					isValidation.push(true)
				} else {
					this.validationData.payment_method_id = ""
					isValidation.push(false)
				}
				if (this.bankRequest.name == "") {
					this.validationData.name = "The name field is required."
					isValidation.push(true)
				} else {
					this.validationData.name = ""
					isValidation.push(false)
				}
				if (this.bankRequest.account_number == "") {
					this.validationData.account_number = "The account number field is required."
					isValidation.push(true)
				} else {
					this.validationData.account_number = ""
					isValidation.push(false)
				}

				if (isValidation.includes(true)) {
					return true
				} else {
					return false
				}
			}
		},
		async mounted() {
			this.filter.page = this.$route.query.page
            this.filter.orderBy = this.$route.query.orderBy
            this.filter.sortKey = this.$route.query.sortKey
			this.bankRequest.id = this.$route.query.id
			await this.getFields()
			await this.getPaymentMethod()
		}
	}
</script>

<style scoped lang="scss">
	.v-text-field--box .v-input__slot,
	.v-text-field--outline .v-input__slot {
		min-height: 56px;
	}
	.banner-image {
		width: 100px;
		height: 100px;
		object-fit: contain;
	}
</style>